module.exports = __webpack_public_path__ + "img/razzo2.e06202c1.png";